import { gql } from '@apollo/client';

export const GET_REPORTING_PERIOD_GROUPS_QUERY = gql`
  query getReportingPeriodGroupsQuery($group_id: String, $company_id: String) {
    reporting_period_groups(group_id: $group_id, company_id: $company_id) {
      id
      deleted
      name
      reference {
        id
        path
        parentPath
      }
    }
  }
`;
